export class VenueContactData {

    public static readonly PRIMARY_CONTACT_ID = "primary";
    public static readonly PRIMARY_SITE_ID = "site";

    id: string;
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;

    useVenueContact: boolean;
}
